import React, { useMemo } from 'react'
import PropTypes from 'prop-types'
import { Spinner, Typography } from 'gu-ui-kit'
import { useTranslation } from 'react-i18next'
import styles from 'modules/Statistics/subcomponents/Layout/ChartLegend/ChartLegend.module.scss'
import clsx from 'clsx'
import formatMoney, { formatByLocale } from 'utils/formatMoney'

export const ChartLegend = ({
  loading = false,
  className = '',
  measure = {},
  metrics = [],
  summary,
  handleClick = () => {},
  include_vat,
  colors,
}) => {
  const { t } = useTranslation(['statistics'])

  const isDataError = useMemo(
    () => !loading && (!summary || (summary && !Object.keys(summary).length)),
    [loading, summary],
  )

  return (
    <div className={clsx(styles['chart-legend'], className)}>
      <div className={styles['chart-legend__list']}>
        {metrics.map(({ id, isHidden }, index) => {
          const value = summary?.[id]
            ? include_vat && summary[id].valueIncludeVat
              ? summary[id].valueIncludeVat
              : summary[id].value
            : null

          return (
            <div
              key={id}
              className={clsx(styles['chart-legend__item'], {
                [styles['chart-legend__item_hidden']]: isHidden,
              })}
            >
              <a
                className={styles['chart-legend__link']}
                onClick={() => handleClick(id)}
                style={
                  isHidden
                    ? {}
                    : {
                        backgroundColor: colors[index],
                        borderColor: colors[index],
                      }
                }
              >
                <Typography
                  variant={'Body-15'}
                  className={styles['chart-legend__link-text']}
                >
                  {t(`chart.legend.labels.${id}`)}
                </Typography>
                {loading && value === null ? (
                  <div style={{ height: '24px' }}>
                    <Spinner
                      width={20}
                      color={'inherit'}
                    />
                  </div>
                ) : value !== null && !isDataError ? (
                  <div
                    dangerouslySetInnerHTML={{
                      __html: measure?.[id]
                        ? `${formatMoney(value, measure?.[id])}`
                        : `${formatByLocale(value, null, {
                            maximumFractionDigits: 2,
                          })}`,
                    }}
                  />
                ) : (
                  '—'
                )}
              </a>
            </div>
          )
        })}
      </div>
    </div>
  )
}

ChartLegend.defaultProps = {
  loading: false,
  className: '',
  metrics: [],
  handleClick: () => {},
  summary: {},
  measure: {},
  include_vat: true,
  colors: [],
}

ChartLegend.propTypes = {
  loading: PropTypes.bool,
  className: PropTypes.string,
  metrics: PropTypes.array,
  handleClick: PropTypes.func,
  summary: PropTypes.object,
  measure: PropTypes.object,
  include_vat: PropTypes.bool,
  colors: PropTypes.array,
}
